// extracted by mini-css-extract-plugin
export var actions = "_2f-0";
export var actionsContainer = "_2f-7";
export var border = "_2f-1";
export var childFullHeight = "_2f-f";
export var collapse = "_2f-2";
export var content = "_2f-a";
export var contentChild = "_2f-e";
export var fullscreen = "_2f-c";
export var hasLeftRadius = "_2f-k";
export var headerContainer = "_2f-3";
export var headerRow = "_2f-5";
export var hidePadding = "_2f-b";
export var navCollapsedGap = "_2f-l";
export var noScrollX = "_2f-m";
export var noScrollY = "_2f-n";
export var noTopPadding = "_2f-i";
export var optOutTopPadding = "_2f-d";
export var pageMain = "_2f-j";
export var pageOuter = "_2f-g";
export var pagePadding = "_2f-8";
export var pageScroll = "_2f-9";
export var profile = "_2f-o";
export var profileContainer = "_2f-p";
export var profileImage = "_2f-q";
export var profileMain = "_2f-r";
export var profileSubtitle = "_2f-t";
export var profileTitle = "_2f-s";
export var showLeftPadding = "_2f-h";
export var tabsPortalSlot = "_2f-6";
export var tabsWrapper = "_2f-4";
export var title = "_2f-u";